import { useMemo } from "react";
import Chart from "react-apexcharts";

const ColumnChart = ({
    categories = [],
    defaultSeries = [],
    label = 'value',
    labelEndAdornment = '',
    labelStartAdornment = ''
}) => {

    const formatNumber = (value) => {
        if (value === undefined || value === null) return '';
        const num = Number(value);
        if (isNaN(num)) return value;
        
        const isCurrency = labelStartAdornment && labelStartAdornment.includes('$');
        return num.toLocaleString('es-CL', {
            minimumFractionDigits: isCurrency ? 2 : (num % 1 === 0 ? 0 : 2),
            maximumFractionDigits: 2
        });
    };

    const options = useMemo(() => {
        return {
            chart: {
                type: 'bar',
                height: 400,
                stacked: true,
                toolbar: {
                    show: true
                },
                zoom: {
                    enabled: true
                }
            },
            responsive: [{
                breakpoint: 480,
                options: {
                    legend: {
                        position: 'bottom',
                        offsetX: -10,
                        offsetY: 0
                    }
                }
            }],
            plotOptions: {
                bar: {
                    horizontal: false,
                    borderRadius: 10,
                    dataLabels: {
                        total: {
                            enabled: true,
                            style: {
                                fontSize: '13px',
                                fontWeight: 900
                            },
                            formatter(val) {
                                return `${labelStartAdornment}${formatNumber(val)}${labelEndAdornment}`;
                            }
                        }
                    }
                },
            },
            dataLabels: {
                formatter(val, opts) {
                    const rawVal = opts.w.config.series[opts.seriesIndex].data[opts?.dataPointIndex];
                    const formattedVal = formatNumber(rawVal);
                    if (label === 'value') {
                        return `${labelStartAdornment}${formattedVal}${labelEndAdornment}`;
                    }

                    if (label === 'valueAndPercent') {
                        return `${labelStartAdornment}${formattedVal}${labelEndAdornment} - ${val.toFixed(1)}%`;
                    }
                    return val;
                }
            },
            xaxis: {
                type: 'string',
                categories: categories,
            },
            legend: {
                position: 'right',
                offsetY: 40
            },
            fill: {
                opacity: 1
            }
        };
    }, [categories, label, labelStartAdornment, labelEndAdornment]);

    const chartWidth = categories.length > 8 ? `${categories.length * 120}px` : '100%';

    return (
        <div 
            style={{
                overflowX: 'auto',
                width: '100%',
                scrollbarWidth: 'thin',
                scrollbarColor: '#cbd5e1 #f8fafc',
            }} 
            className="custom-chart-scrollbar"
        >
            <div 
                style={{
                    width: chartWidth,
                    minWidth: '100%',
                    transition: 'width 0.3s ease'
                }}
            >
                <Chart options={options} series={defaultSeries} type="bar" height={400} />
            </div>

            <style dangerouslySetInnerHTML={{__html: `
                .custom-chart-scrollbar::-webkit-scrollbar {
                    height: 8px;
                }
                .custom-chart-scrollbar::-webkit-scrollbar-track {
                    background: #f8fafc;
                    border-radius: 4px;
                }
                .custom-chart-scrollbar::-webkit-scrollbar-thumb {
                    background: #cbd5e1;
                    border-radius: 4px;
                }
                .custom-chart-scrollbar::-webkit-scrollbar-thumb:hover {
                    background: #94a3b8;
                }
            `}} />
        </div>
    );
};

export default ColumnChart;